import mockIMG from "@assets/img/product1.png";
import { ItemData } from "./types";

export function mapApiToItemData(apiItem: any): ItemData {
  return {
    title: apiItem.item_name || "No title",
    img: apiItem.image_link || mockIMG,
    asin: apiItem.asin,
    rating: 4.5,
    value: apiItem.price || 0,
    variations: false,
    status: "active",
    variants: [],
    brand: apiItem.brand || "",
  };
}

export function filterList(
  items: ItemData[],
  isBrandSelect: boolean,
  isAsinSelect: boolean,
  brandSelected: string[],
  asinSelected: string[],
): ItemData[] {
  if (isAsinSelect && asinSelected.length > 0) {
    return items.filter((item) => asinSelected.includes(item.asin));
  }
  if (isBrandSelect && brandSelected.length > 0) {
    return items.filter((item) => brandSelected.includes(item.brand));
  }
  return items;
}
